module.exports = __webpack_public_path__ + "img/e-wallet-ss-new.ee1f61d3.jpg";